import packageJson from '../../package.json';
import type { Country } from '../entities/Country';
import type { UseCase } from '../entities/enums';

import { getAvailablePaymentMethods } from './getAvailablePaymentMethods';

// const isPaymentDetailsHidden = (
//   totalOrderAmountPayable: number | undefined,
//   hidePrice: boolean | undefined,
// ): boolean => {
//   const isFreeProduct = Boolean(Number(totalOrderAmountPayable) === 0);

//   return Boolean(hidePrice || isFreeProduct);
// };

// const isInvoiceOnly = (contractBalances: any): boolean =>
//   contractBalances !== undefined && contractBalances.length > 0;

export function generatePaymentsViewDataForCaja(
  orderSummary: any,
  hirerAccount: any,
  isCajaUpsell: boolean,
  isCpqa: boolean,
  country: Country,
  features: string[],
  useCase: UseCase,
  invoiceOnly: boolean,
  hideAllPayments: boolean,
) {
  const totalOrderAmountPayable = Number((orderSummary.total.value || 0) / 100);

  const hasSufficientBudget =
    (hirerAccount?.contractsSummary?.hasAnyActiveBudgetContracts &&
      totalOrderAmountPayable === 0) ||
    false;

  const isPayment = totalOrderAmountPayable > 0;

  // temporary comment for later cart integration use
  // const invoiceOnly = isInvoiceOnly(contractBalances);

  // temporary comment for later cart integration use
  // const hideAllPayments = isPaymentDetailsHidden(
  //   totalOrderAmountPayable,
  //   hirerAccount?.hidePrice,
  // );

  const paymentMethodShown = hideAllPayments
    ? 'not shown'
    : getAvailablePaymentMethods({
        country,
        features,
        invoiceOnly,
        isCpqa,
        isCajaUpsell,
        useCase,
      });

  return {
    widget_displayed_data: {
      hasSufficientBudget,
      isPayment,
      orderSummaryTotalPrice:
        totalOrderAmountPayable > 0 ? totalOrderAmountPayable.toFixed(2) : 0,
      paymentMethodShown,
      paymentsWidgetVersion: packageJson.version,
    },
    // hideAllPayments,
    // invoiceOnly,
  };
}

export function generatePaymentsViewDataForInvoice(
  country: Country,
  features: string[],
  useCase: UseCase,
  isMultipleInvoice?: boolean,
) {
  const paymentMethodShown = getAvailablePaymentMethods({
    country,
    features,
    useCase,
    isMultipleInvoice,
  });

  return {
    widget_displayed_data: {
      paymentMethodShown,
      paymentsWidgetVersion: packageJson.version,
    },
  };
}
